import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Help = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <h1 className="mb-4">Help Center</h1>
          <p className="lead">
            Welcome to our Help Center. Here you'll find answers to common
            questions and resources to help you get the most out of Airclift
            Capital.
          </p>

          <div className="mt-5">
            <h3>Frequently Asked Questions</h3>
            <div className="mt-3">
              <h5>How do I get started?</h5>
              <p>
                Contact our team to discuss your institutional needs and get
                onboarded.
              </p>

              <h5>What are the minimum deposit requirements?</h5>
              <p>
                Our minimum deposit varies by account type. Please contact us
                for specific details.
              </p>

              <h5>How secure is the platform?</h5>
              <p>
                We use institutional-grade security measures including
                multi-signature wallets and cold storage.
              </p>
            </div>
          </div>

          <div className="mt-5">
            <h3>Need More Help?</h3>
            <p>
              If you can't find what you're looking for, please{" "}
              <a href="/contact" className="text-primary">
                contact our support team
              </a>{" "}
              directly.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Help;
